import type {
  Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailItemDto,
  Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { PARTICIPATION_TYPE } from '@/pages/cap-table/charter-stock-classes/utils/stockClassParticipationFieldConfig';

export function mapExistingClassFormRowToDetailItem(
  row: Record<string, unknown>,
): Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailItemDto {
  const dividendTypeRaw = row.dividendType;
  return {
    detailId: row.detailId as string,
    className: ((row.name as string) || (row.className as string)) ?? undefined,
    defaultIdPrefix: (row.defaultIdPrefix as string | undefined) ?? null,
    classType: row.classType != null && row.classType !== '' ? Number(row.classType) : undefined,
    totalAuthorized: Number(String(row.authorizedShares).replace(/,/g, '')),
    votesPerShare:
      row.votesPerShare != null && row.votesPerShare !== ''
        ? Number(row.votesPerShare)
        : null,
    seniority:
      row.seniority != null && row.seniority !== '' ? Number(row.seniority) : null,
    liquidationPreferenceMultiple:
      row.liquidationPreferenceMultiple != null && row.liquidationPreferenceMultiple !== ''
        ? Number(row.liquidationPreferenceMultiple)
        : null,
    participationType:
      row.participationType != null && row.participationType !== ''
        ? Number(row.participationType)
        : undefined,
    participationCapMultiple:
      Number(row.participationType) === PARTICIPATION_TYPE.PARTICIPATING_WITH_CAP &&
      row.participationCapMultiple != null &&
      row.participationCapMultiple !== ''
        ? Number(row.participationCapMultiple)
        : null,
    conversionRatio:
      row.conversionRatio != null && row.conversionRatio !== ''
        ? Number(row.conversionRatio)
        : null,
    parValue:
      row.parValue != null && row.parValue !== '' ? Number(row.parValue) : null,
    isNoParValue: false,
    splitMultiplier:
      row.splitMultiplier != null && row.splitMultiplier !== ''
        ? Number(row.splitMultiplier)
        : null,
    originalIssuePrice:
      row.originalIssuePrice != null && row.originalIssuePrice !== ''
        ? Number(row.originalIssuePrice)
        : null,
    dividendRate:
      row.dividendRate != null && row.dividendRate !== ''
        ? Number(row.dividendRate)
        : null,
    dividendType:
      dividendTypeRaw != null && dividendTypeRaw !== ''
        ? Number(dividendTypeRaw)
        : undefined,
    clearDividendType: dividendTypeRaw === '' ? true : undefined,
  };
}

export function mapExistingClassFormRowsToDetailsPayload(
  charterFilingId: string,
  rows: Record<string, unknown>[],
): Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto {
  return {
    charterFilingId,
    details: rows.map(mapExistingClassFormRowToDetailItem),
  };
}

export function mapEditedRowsToDetailsPayload(
  charterFilingId: string,
  editedRows: Record<string, unknown>[],
): Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto {
  return {
    charterFilingId,
    details: editedRows.map((row) => ({
      detailId: row.id as string,
      className: row.name as string,
      defaultIdPrefix: (row.preFix as string | null | undefined) ?? null,
      classType: row.classType as number,
      totalAuthorized:
        row.authorizedShares != null ? Number(row.authorizedShares) : null,
      votesPerShare: row.votesPerShare != null ? Number(row.votesPerShare) : null,
      seniority: row.seniority != null ? Number(row.seniority) : null,
      conversionRatio:
        row.conversionRatio != null ? Number(row.conversionRatio) : null,
      splitMultiplier:
        row.splitMultiplier != null ? Number(row.splitMultiplier) : null,
      parValue: row.parValue != null ? Number(row.parValue) : null,
      originalIssuePrice:
        row.originalIssuePrice != null && row.originalIssuePrice !== ''
          ? Number(row.originalIssuePrice)
          : null,
      dividendRate:
        row.dividendRate != null && row.dividendRate !== ''
          ? Number(row.dividendRate)
          : null,
      dividendType:
        row.dividendType != null && row.dividendType !== ''
          ? Number(row.dividendType)
          : undefined,
      clearDividendType: row.dividendType === '' ? true : undefined,
    })),
  };
}
